import type {FetchBaseQueryArgs} from '@reduxjs/toolkit/query/react';
import {Configuration} from 'configuration';
import {prepareHeaders} from './prepareHeaders';

export const createBaseQueryArgs: FetchBaseQueryArgs = {
  baseUrl: Configuration.api.baseUri,
  prepareHeaders,
};
